import makeStyles from '@mui/styles/makeStyles'

const HORIZONTAL_PADDING = '13px'

const useStyles = makeStyles(theme => ({
  children: {
    cursor: 'pointer'
  },

  disabled: {
    cursor: 'default'
  },

  options: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    border: '1px solid #E6EAEC',
    borderRadius: '6px',
    boxSizing: 'border-box',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.04)',
    width: ({ width, autoWidth }) => (autoWidth ? 'unset' : width || 'unset'),
    padding: `0 ${HORIZONTAL_PADDING}`,
    background: '#FFFFFF',
    overflow: 'hidden'
  },

  option: {
    marginLeft: `-${HORIZONTAL_PADDING}`,
    width: `calc(100% + ${HORIZONTAL_PADDING})`,
    padding: `8px 0 8px ${HORIZONTAL_PADDING}`,
    cursor: 'pointer',
    transition: 'background-color 200ms',

    '&:hover': {
      backgroundColor: '#E6EAEC'
    }
  }
}))

export default useStyles
